import { IconProps } from "@/src/sb/business-layer/types"

const SplitPanel = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 14 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {" "}
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 0H1C0.447715 0 0 0.447715 0 1V11C0 11.5523 0.447715 12 1 12H13C13.5523 12 14 11.5523 14 11V1C14 0.447715 13.5523 0 13 0ZM1 1H4V11H1V1ZM13 11H5V1H13V11Z"
      fill="currentColor"
    />
  </svg>
)

export default SplitPanel
